import moment from 'moment';

interface Employee {
  id: string;
  company_id: string;
  first_name: string;
  last_name: string;
  email: string;
  impersonated: boolean;
  settings: {
    country: string;
  };
  company_detail?: {
    features?: {
      marketplace: boolean;
      marketplace_international: boolean;
    };
  };
  employee_wallets?: Array<{
    amount: number;
    company_wallet_configuration: {
      is_twic_store_enabled?: boolean;
    };
    next_reset_date: string;
  }>;
}

const expiringSoon = (date: string) =>
  // for the minimum, we need to compare down to the ms for diff of less than 1 day
  moment(date).diff(moment()) >= 0 && moment(date).diff(moment(), 'days') < 10;

const isStoreEnabled = (employee: Employee) => {
  const is_member_us_citizen = employee.settings.country === 'us';

  const is_forma_store_enabled = employee.company_detail?.features?.marketplace;
  const is_international_store_enabled =
    employee.company_detail?.features?.marketplace_international;

  return (
    (is_forma_store_enabled && is_member_us_citizen) ||
    (is_international_store_enabled && !is_member_us_citizen)
  );
};

const createUserFromEmployee = (employee: Employee) => ({
  key: employee.id,
  anonymous: false,
  firstName: employee.first_name,
  lastName: employee.last_name,
  country: employee.settings.country,
  email: employee.email,
  custom: {
    companyId: employee.company_id,
    hasExpiringFunds:
      employee.employee_wallets?.some(
        (ew) => expiringSoon(ew.next_reset_date) && ew.amount > 0
      ) ?? false,
    storeEnabled: isStoreEnabled(employee) ?? false,
    impersonateAsCustomer: Boolean(employee.impersonated),
  },
});

export { createUserFromEmployee };
